import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./LibraryLessonCardAmountComplete.module.scss";
import {isUndefined} from "../../../util/is-type";

export interface ILibraryLessonCardAmountCompleteProps {
  value?: number | string;
}

export const LibraryLessonCardAmountComplete: VoidFunctionComponent<ILibraryLessonCardAmountCompleteProps> = ({value}) => {
  if (isUndefined<number | string>(value) || !value) {
    // not completed, return nothing
    return null;
  }
  return <div className={s.amountComplete}>{value}</div>;
}
